import { useCallback } from "react";

export default function Pagination({ currentPage, totalPages, onPageChange }) {

    const getPageNumbers = useCallback(() => {
        const pages = [];
        const maxVisible = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);

        if (endPage - startPage < maxVisible - 1) {
            startPage = Math.max(1, endPage - maxVisible + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    }, [currentPage, totalPages]);

    return (
        <div className="flex flex-wrap items-center justify-center space-x-2 mt-4 mb-4">
            {/* First Page */}
            <button
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded-lg cursor-pointer transition bg-white hover:bg-[#301762] hover:text-white"
            >
                First
            </button>

            {/* Previous Button */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded-lg cursor-pointer transition bg-white hover:bg-[#301762] hover:text-white"
            >
                Prev
            </button>

            {/* Page Numbers */}
            {getPageNumbers().map((page) => (
                <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={`px-3 py-1 border rounded-lg transition text-xs sm:text-sm ${page === currentPage
                        ? "bg-[#301762] text-white"
                        : "bg-white hover:bg-[#301762] hover:text-white"
                        }`}
                >
                    {page}
                </button>
            ))}

            {/* Next Button */}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded-lg cursor-pointer transition bg-white hover:bg-[#301762] hover:text-white"
            >
                Next
            </button>

            {/* Last Page */}
            <button
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded-lg cursor-pointer transition bg-white hover:bg-[#301762] hover:text-white"
            >
                Last
            </button>
        </div>
    );
};